module.exports = "/packs/images/homepage/whatson/october_offers_desktop~9363ffea6735f73b65d8db3c67c04843.jpg";